import { render, staticRenderFns } from "./After_sales.vue?vue&type=template&id=6e700243&scoped=true&"
import script from "./After_sales.vue?vue&type=script&lang=js&"
export * from "./After_sales.vue?vue&type=script&lang=js&"
import style0 from "./After_sales.vue?vue&type=style&index=0&id=6e700243&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e700243",
  null
  
)

export default component.exports